import React, { useState } from 'react';
import api from '../utils/api';

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [fout, setFout] = useState('');
  const [laden, setLaden] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFout(''); setLaden(true);
    try {
      const { data } = await api.post('/auth/login', { email, wachtwoord });
      onLogin(data.gebruiker, data.token);
    } catch {
      setFout('Ongeldig e-mailadres of wachtwoord');
    } finally { setLaden(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1F3864 0%, #185FA5 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '40px 36px', width: 380, boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo.png" alt="Spoo Linssen" style={{ width: 200, display: 'block', margin: '0 auto 12px' }} />
          <div style={{ fontSize: 13, color: '#888', fontWeight: 500 }}>Productieplanning</div>
        </div>
        {fout && <div style={{ background: '#FCEBEB', color: '#791F1F', padding: '8px 12px', borderRadius: 6, fontSize: 13, marginBottom: 16 }}>{fout}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>E-mailadres</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
              style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14 }}
              placeholder="admin@bedrijf.be" />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 4 }}>Wachtwoord</label>
            <input type="password" value={wachtwoord} onChange={e => setWachtwoord(e.target.value)} required
              style={{ width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14 }} />
          </div>
          <button type="submit" disabled={laden}
            style={{ width: '100%', padding: '10px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 600, cursor: laden ? 'wait' : 'pointer' }}>
            {laden ? 'Bezig...' : 'Inloggen'}
          </button>
        </form>
      </div>
    </div>
  );
}
